<template>
  <div class="multi-image-upload">
    <div class="upload-area" @paste="handlePaste" tabindex="0">
      <div v-if="previewImages.length === 0" class="upload-prompt">
        <div class="upload-hint">请粘贴图片或点击上传 (支持多张)</div>
      </div>
      <div v-else class="preview-container">
        <div class="image-grid">
          <div
            v-for="(image, index) in previewImages"
            :key="index"
            class="image-item"
          >
            <el-image
              :src="image.preview"
              alt="质检凭证预览"
              class="preview-image"
              :preview-src-list="[image.preview]"
            />
            <div class="image-actions">
              <el-button
                size="mini"
                type="danger"
                icon="el-icon-delete"
                circle
                @click.stop="removeImage(index)"
              ></el-button>
            </div>
          </div>
        </div>
      </div>

      <input
        type="file"
        ref="fileInput"
        accept="image/*"
        multiple
        @change="handleFileSelect"
        style="display: none;"
      />
    </div>

    <div v-if="message" :class="['message', messageType]">
      {{ message }}
    </div>

    <!-- 上传进度 -->
    <el-progress
      v-if="uploadProgress > 0 && uploadProgress < 100"
      :percentage="uploadProgress"
      :status="uploadStatus"
      style="margin-top: 15px;"
    ></el-progress>
  </div>
</template>

<script>
export default {
  name: "inputUpload",
  components: {},
  data() {
    return {
      previewImages: [], // 格式: [{ preview: 'base64', file: File }]
      uploading: false,
      uploadProgress: 0,
      uploadStatus: "", // 'success', 'exception'
      message: "",
      messageType: "info"
    };
  },
  computed: {},
  watch: {},
  methods: {
    // 触发文件选择对话框
    triggerFileInput() {
      if (this.previewImages.length === 0) {
        this.$refs.fileInput.click();
      }
    },

    // 处理文件选择
    handleFileSelect(event) {
      const files = Array.from(event.target.files);
      if (files.length === 0) return;

      this.processImageFiles(files);
    },

    // 处理粘贴事件
    handlePaste(event) {
      event.preventDefault();
      const clipboardItems = event.clipboardData.items;
      const imageFiles = [];

      for (let i = 0; i < clipboardItems.length; i++) {
        const item = clipboardItems[i];
        if (item.type.indexOf("image") !== -1) {
          const blob = item.getAsFile();
          if (blob) {
            imageFiles.push(blob);
          }
        }
      }

      if (imageFiles.length > 0) {
        this.processImageFiles(imageFiles);
      } else {
        this.showMessage("剪贴板中没有检测到图片", "info");
      }
    },

    // 处理多个图片文件
    processImageFiles(files) {
      const validFiles = files.filter(file => {
        if (!file.type.match("image.*")) {
          this.showMessage(`文件 ${file.name} 不是图片类型，已跳过`, "warning");
          return false;
        }

        if (file.size > 5 * 1024 * 1024) {
          this.showMessage(`图片 ${file.name} 超过5MB限制，已跳过`, "warning");
          return false;
        }

        return true;
      });

      if (validFiles.length === 0) return;

      // 处理每个文件
      validFiles.forEach(file => {
        const reader = new FileReader();
        reader.onload = e => {
          this.previewImages.push({
            preview: e.target.result,
            file: file
          });
        };

        reader.readAsDataURL(file);
      });
      const allFiles = this.previewImages.map(item => item.file).concat(validFiles);
      this.$emit("copySuccesss", allFiles);
      //   this.showMessage(`已添加 ${validFiles.length} 张图片`, "success");
    },

    // 移除单张图片
    removeImage(index) {
      this.previewImages.splice(index, 1);
      let validFiles = this.previewImages.reduce(
        (acc, item) => acc.concat(item.file),
        []
      );
      this.$emit("copySuccesss", validFiles);
    },
    // 显示消息
    showMessage(text, type = "info") {
      this.message = text;
      this.messageType = type;
    }
  },

  created() {},
  mounted() {
    // 确保容器可聚焦
    this.$el.querySelector(".upload-area").focus();
  }
};
</script>
<style scoped>
.multi-image-upload {
  width: 430px;
  /* max-width: 800px; */
  margin: 0 auto;
}

.upload-area {
  border: 1px dashed #dcdfe6;
  border-radius: 6px;
  /* padding: 10px; */
  text-align: center;
  cursor: pointer;
  transition: border-color 0.3s;
  outline: none;
  min-height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.upload-area:hover {
  border-color: #409eff;
}

.upload-prompt {
  color: #606266;
}

.upload-text {
  font-size: 16px;
  font-weight: bold;
  margin: 10px 0;
}

.upload-hint {
  font-size: 14px;
  color: #909399;
}

.el-icon-upload {
  font-size: 40px;
  color: #c0c4cc;
}

.preview-container {
  width: 100%;
}

.image-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
  gap: 0px;
}

.image-item {
  position: relative;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  overflow: hidden;
  height: 80px;
}

.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-actions {
  position: absolute;
  top: 5px;
  right: 5px;
}

.upload-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 15px;
}

.message {
  margin-top: 10px;
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
}

.message.info {
  color: #909399;
  background-color: #f4f4f5;
}

.message.success {
  color: #67c23a;
  background-color: #f0f9eb;
}

.message.error {
  color: #f56c6c;
  background-color: #fef0f0;
}

.message.warning {
  color: #e6a23c;
  background-color: #fdf6ec;
}
</style>
